import axios from 'axios'
import logger from './logger'
import { MODULES_NAMES } from '../modules/modulesList'

const BaseUri = `${process.env.REACT_APP_FLASK_SVC_URL}/web/`

// logic to compensate incomplete TEST environment,
// and reroute missing pages to
const isBackupUriSet = process.env.REACT_APP_FLASK_SVC_URL_BACKUP !== undefined
const BackupUri = `${process.env.REACT_APP_FLASK_SVC_URL_BACKUP}/web/`
const ENTITIES_USE_BACKUP_URI = [
  MODULES_NAMES.SHIPPING,
  // MODULES_NAMES.ORDERS,
  // MODULES_NAMES.INVOICES,
]

const FORCE_USE_MOCKS = [
  // MODULES_NAMES.HOLIDAYS
]

const needMocks = (moduleName) => {
  return process.env.REACT_APP_GET_MOCK_DATA === '1' ||
    FORCE_USE_MOCKS.includes(moduleName)
}

const makeApiUri = (useMocks, moduleName) => {
  let prefix = BaseUri;
  if (isBackupUriSet && ENTITIES_USE_BACKUP_URI.includes(moduleName)) {
    prefix = BackupUri
  }
  return useMocks ? `/${moduleName}.json` : `${prefix}${moduleName}/`
}

class ApiRequest {
  static async get(moduleName) {
    const useMocks = needMocks(moduleName)
    const uri = makeApiUri(useMocks, moduleName)

    let parsed = {};
    if (!useMocks) {
      const userInfo = localStorage.getItem('userInfo')
      if (!userInfo || userInfo === '{}') {
        window.alert("Cannot find user login info. Please Logout and log back in to access this page")
        throw new Error("Need to login")
      }
      parsed = JSON.parse(userInfo)
    }

    logger.info(`[AXIOS] call to ${uri}`)
    return axios
      .get(uri, {
        auth: { username: parsed.username, password: parsed.password },
      }).catch((error) => {
        throw new Error(`[AXIOS] Error getting ${uri} (${error})`)
      })
  }
}

export const islocalHost = () => {
  return window.location.host.indexOf('localhost') > -1
}

export const isDevHost = () => {
  return window.location.host.includes('dev.')
}

export default ApiRequest
